import * as constants from './constants'

const initialState = {
    location: null,
    promo: null,
    ticket: null,
}

export const reducer = (state = initialState, { type, location, promo, ticket }) => {
    switch (type) {
        case constants.GET_SCANTICKET_LOCATION_SUCCESS:
            return { ...state, location }
        case constants.REDEEM_SCANTICKET_PROMO_SUCCESS:
            return { ...state, promo }
        case constants.SCAN_TICKET_SUCCESS:
            return { ...state, ticket }
        case constants.REMOVE_SCANTICKET_PROMO:
            return { ...state, promo: initialState.promo }
        case constants.CLEAR_SCANTICKET: {
            return initialState
        }
        default:
            return state
    }
}
